// extracted by mini-css-extract-plugin
export default {"title":"Competitors_title__+JOe7"};